import { analyticsService } from "@services/analyticsService";
import { GetMissingFieldsLevelParameter } from "@wingspanhq/wingspan-api-sdk";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_PAYER } from "..";
import { useQueryPrimaryComplianceEntity } from "../../../shared/hooks/useQueryPrimaryComplianceEntity";
import { selectorComplianceEntityCountry } from "../../../shared/selectors/selectorComplianceEntityCountry";
import { queriesOnboarding } from "@query";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";

const payerOnboardingModules: OnboardingModule[] = [
  {
    type: "create_account",
    options: {
      accountTypes: ["Business"],
      verificationLevel: GetMissingFieldsLevelParameter.BANKING
    }
  },
  { type: "additional_information" },
  {
    type: "payroll_funding_method"
  },
  {
    type: "payroll_settings"
  },
  {
    type: "business_profile"
  }
];

export const RoutePayerOnboarding: React.FC = () => {
  const history = useHistory();
  const queryCustomerEntity = useQueryPrimaryComplianceEntity();
  const queryVerifications = queriesOnboarding.getOnboardingStatus.useQuery(
    undefined,
    { select: status => status.verifications }
  );

  return (
    <OnboardingFlow
      basePath={PATH_ONBOARDING_PAYER}
      modules={payerOnboardingModules}
      onSuccess={() => {
        history.push("/member/dashboard");

        analyticsService.track("Onboarding Completed", {
          onboardingType: "payer",
          entityType: queryCustomerEntity.data?.type,
          entityCountry: selectorComplianceEntityCountry(
            queryCustomerEntity.data
          ),
          taxVerificationStatus: queryVerifications.data?.tax,
          bankingVerificationStatus: queryVerifications.data?.banking,
          enhancedVerificationStatus: queryVerifications.data?.enhanced
        });
      }}
    />
  );
};
